import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import * as XLSX from 'xlsx';
import { Validators, FormControl } from "@angular/forms";
import { PayoutService } from 'src/app/services/payout.service';
import { Router } from "@angular/router";
const swal = require('sweetalert');
@Component({
  selector: 'app-manage-payout-contacts',
  templateUrl: './manage-payout-contacts.component.html',
  styleUrls: ['./manage-payout-contacts.component.scss']
})
export class ManagePayoutContactsComponent implements OnInit {
  datePickerMaxDate

  ViewPayoutCustomerkeyId:any;
ViewCustomerAccountId:any;
ViewCustomerId:any;
ViewCompanyName:any;
ViewFirstName:any;
ViewLastName:any;
ViewAddress:any;
ViewCity:any;
ViewState:any;
ViewCountry:any;
ViewZipCode:any;
ViewMobileNo:any;
ViewMobileNo2:any;
ViewEmail:any;
ViewEmail2:any;
ViewUpdatedDatetime:any;
ViewUserDefined1:any;
ViewUserDefined2:any;
ViewUserDefined3:any;
ViewUserDefined4:any;
ViewUserDefined5:any;
ViewUserDefined6:any;
ViewUserDefined7:any;
ViewUserDefined8:any;
ViewUserDefined9:any;
ViewUserDefined10:any;

  viewpayout:boolean=true;
  newpayout:boolean=false;
  editpayout:boolean=false;
  deletepayout:boolean=false;
  createTransaction:boolean=false;
  hidebeneficiary:boolean=false;
  Addbenificiaries:boolean=false
  accountbal;
  step1 = true; 
  step2 = false;
  step3 = false;
  step4 = false;
  PayoutCustomerkeyId:any;
  Tourtransaction:any;
  getinfo:any;
  excelTansactionDataResponse = [];
  isreportsbtnActive: boolean = false;
  fromdate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  CustomerId= new FormControl("", [Validators.required]);
  MobileNo= new FormControl("", [Validators.required]);
  Name= new FormControl("", [Validators.required]);
  CompanyName= new FormControl("", [Validators.required]);
  filtering: boolean = false;
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  Workclose= true;
  PayoutStep1 = true;
  PayoutStep2 = false;
  PayoutStep3 = false;
  PayoutStep4 = false;
  PayoutTour= true;
  tourDiv= false;
  editing = {};
  rows = [];
  datas:any;
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  temp = [];
  expanded: any = {};
  timeout: any;
  rowsSel = [];
  selected = [];
  MerchantKeyId:any;
  loggedinuseremail:any;
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  daterange = new FormControl("", [Validators.required]);
  PCustomerkeyId:any;
  
  constructor(private commonfunction: CommonFunctionService,private transactionservice: TransactionService,private service: PayoutService,private router:Router) { }

  ngOnInit() {
    this.getUserPermissions();
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
  //   this.service.ViewAccountBalance(merchantdata.MerchantKeyId).subscribe(result => {
  //    if(result !=null)
  //    {
  //      this.accountbal=result;
       
       
  //    }
      
  
  //  }) 
    this.getinfo=localStorage.getItem('SettingDetails')
    var Transaction=this.getinfo;
    let jsonObj: any = JSON.parse(this.getinfo);
    
    if(jsonObj !=null)
    {
   this.Tourtransaction=jsonObj.ProductKnowledgeGuide_ProductTourPayoutContact;
   if(this.Tourtransaction ==false)
   {
     this.SkipTour();
   }
  }
    this.GetPayOutconatctdetails();
  }

  checkRangeType()
  {
    var daterange=this.daterange.value;
    if(daterange=="Custom Date Range")
    {
     this.isCustomDateSelected = true;
     this.isStartDateGreaterthenEndDate = false;
        this.Rfromdate=true;
       this. Dfiltering=false;
       this.fromdate.setValue('');
       this.todate.setValue('');
       this.isreportsbtnActive = true;
    }
    else{
     this.isCustomDateSelected = false;
     this.isStartDateGreaterthenEndDate = false;
     this.Rfromdate=false;   
    }
  }

  selectedaterange() {

    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;

    }

    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
       this.search();



    }

  }


  GetPayOutconatctdetails() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
    this.GetPayOutconatctdetailsList((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);

    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
     if (charCode > 31 && (charCode < 48 || charCode > 57)) {
     return false;
     }
     return true;
      }

  GetPayOutconatctdetailsList(cb) {
      const req = new XMLHttpRequest();
      this.service.getpayoutcontactList(this.MerchantKeyId,this.loggedinuseremail).subscribe(data => {

      if(data !=null)
      {
        this.temp = _clone(data);
        this.rows = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
      }
    });
      // req.open('GET', environment.getpayoutcontactList + "?MerchantKeyId=" + this.MerchantKeyId + "&UserId="+this.loggedinuseremail);
     
      // req.onload = () => {
      //   cb(JSON.parse(req.response));
      // };
  
      // req.send();
    }


    filters() {
      this.filtering = !this.filtering;
    }
    next2() {
      this.step1 = false; 
      this.step2 = true;  
      this.step3 = false;
      this.step4 = false;
    }
    next3() {
      this.step1 = false; 
      this.step2 = false;  
      this.step3 = true;
      this.step4 = false;
    }
    next4() {
      this.step1 = false; 
      this.step2 = false;  
      this.step3 = false;
      this.step4 = true;
    }
    back1(){
      this.step1 = true; 
      this.step2 = false;
      this.step3 = false;
      this.step4 = false;
    }
    back2(){
      this.step1 = false; 
      this.step2 = true;
      this.step3 = false;
      this.step4 = false;
    }
    back3(){
      this.step1 = false; 
      this.step2 = false;
      this.step3 = true;
      this.step4 = false;
    }
  
    close(){
      this.Workclose= false;
  }
    Nextstep() {
      this.PayoutStep1 = false;
      this.PayoutStep2 = true;
      this.PayoutStep3 = false;
      this.PayoutStep4 = false;
      this.PayoutTour = false;
      this.tourDiv= true;
    
    }
    Nextstep1() {
      this.PayoutStep1 = false;
      this.PayoutStep2 = false;
      this.PayoutStep3 =true;
      this.PayoutStep4 = false;
      this.PayoutTour = false;
      this.tourDiv= true;
    
    }
    Nextstep2() {
      this.PayoutStep1 = false;
      this.PayoutStep2 = false;
      this.PayoutStep3 =false;
      this.PayoutStep4 = true;
      this.PayoutTour = false;
      this.tourDiv= true;
    
    }
   
  
    GetStarted() {
      this.PayoutStep2 = false; 
      this.PayoutTour = true;
      this.tourDiv = false;
      this.PayoutStep1 = false;
      this.PayoutStep3 =false;
      this.PayoutStep4 = false;
      
    }
    backSubmit() {
      this.PayoutStep1 = true;
      this.PayoutStep2 = false;
      this.PayoutStep3 = false;
      this.PayoutStep4 = false;
      this.PayoutTour = false;
      this.tourDiv = true;
   
    }
    backSubmit1() {
      this.PayoutStep1 = false;
      this.PayoutStep2 = true;
      this.PayoutStep3 = false;
      this.PayoutStep4 = false;
      this.PayoutTour = false;
      this.tourDiv = true;
   
    }
    backSubmit2() {
      this.PayoutStep1 = false;
      this.PayoutStep2 = false;
      this.PayoutStep3 = true;
      this.PayoutStep4 = false;
      this.PayoutTour = false;
      this.tourDiv = true;
   
    }
    GotoTour(){
      this.tourDiv = true; 
      this.PayoutTour = false;
      this.PayoutStep2 = false;
      this.PayoutStep1 = true;
      this.PayoutStep3 = false;
      this.PayoutStep4 = false;

    }
    SkipTour(){
      this.tourDiv = false; 
      this.PayoutTour = true;
      this.PayoutStep2 = false;
      this.PayoutStep1 = false;
      this.PayoutStep3 = false;
      this.PayoutStep4 = false;
    }
  


    search() {
      this.GetPayOutcontactfilter((data) => {
        // cache our list
        // this.temp = _clone(data);
        // this.rows = _clone(data);;
        // this.rowsFilter = _clone(data);;
        // this.rowsExp = _clone(data);
        // this.rowsSort = _clone(data);
        // this.rowsSel = _clone(data);
      });
   
    }
    GetPayOutcontactfilter(cb) {
      var daterange = this.daterange.value;
      if(daterange=="" || daterange=="null")

      {

        daterange="";

      }
      var Cid = this.CustomerId.value;
      var Cname = this.CompanyName.value;
      var Name = this.Name.value;
      var MobileNo = this.MobileNo.value;
  
      if (daterange == "Today") {
        this.Fromdate1 = new Date().toISOString().slice(0, 10);
        this.todate1 = new Date().toISOString().slice(0, 10);
  
  
      }
      else if (daterange == "Yesterday") {
        const today = new Date();
        const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
        this.Fromdate1 = tomorrow;
        this.todate1 = tomorrow;
  
      }
      else if (daterange == "current week") {
        const today = new Date();
        const tomorrow = new Date(today.setDate(today.getDay()));
  
  
        var current = new Date();
        var weekstart = current.getDate() - current.getDay() + 1;
        var weekend = weekstart + 6;
        this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
        this.todate1 = new Date().toISOString().slice(0, 10);
  
      }
      else if (daterange == "Last Week") {
        var curr = new Date;
        var first = curr.getDate() - curr.getDay() - 6;
        var last = first + 6;
        this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
        this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);
  
  
      }
      else if (daterange == "This Month") {
        const today = new Date();
        // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
        //this.Fromdate1=thismonth;   
        this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
        this.todate1 = new Date().toISOString().slice(0, 10);
  
      }
      else if (daterange == "Last Month") {
        // var date = new Date();                
        // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
        // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
        var date = new Date();
        this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
        this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();
  
  
      }
      else if (daterange == "Custom Date Range") {
  
        this.Fromdate1 = this.fromdate.value;
        this.todate1 = this.todate.value;
      }
      else {
        this.Fromdate1 = '01/01/1990';
        // this.Fromdate1 = new Date().toISOString().slice(0, 10);
        this.todate1 = new Date().toISOString().slice(0, 10);
      }
  
      const req = new XMLHttpRequest();


      this.service.viewPayOutFilterdataurl(this.MerchantKeyId,this.Fromdate1,this.todate1,Cname,Cid,Name,MobileNo).subscribe(data => {

      if(data !=null)
      {
        this.temp = _clone(data);
        this.rows = _clone(data);;
        this.rowsFilter = _clone(data);;
        this.rowsExp = _clone(data);
        this.rowsSort = _clone(data);
        this.rowsSel = _clone(data);
      }
    });
      // req.open('GET',
      //   environment.viewPayOutFilterdataurl + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&CompayName=" + Cname
      //   + "&CustomerId=" + Cid +"&CustomerName=" + Name  + "&MobileNumber=" + MobileNo);
      // req.onload = () => {
      //   cb(JSON.parse(req.response));
      // };
  
      // req.send();
    }



    checkDateRange() {
      if (this.fromdate.value != "" && this.todate.value != "") {
        if (this.fromdate.value > this.todate.value) {
          this.isreportsbtnActive = false;
          this.isStartDateGreaterthenEndDate = true;
        }
        else {
          this.isreportsbtnActive = true;
          this.isStartDateGreaterthenEndDate = false;
        }
      }
      else {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = false;
      }
    }




    ShowMeAgain()
    {
      var Type="Manage PayOut Contact";
      const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
      this.transactionservice.UpdateManageTransactionSettings(merchantdata.MerchantKeyId,merchantdata.UserId,Type).subscribe(result => {
        if(result !=null)
        {
          localStorage.removeItem('SettingDetails');
          this.transactionservice.GetUserPreferenceSettings(merchantdata.MerchantKeyId,merchantdata.UserId).subscribe(result => {
            if(result !=null)
            {
             localStorage.setItem("SettingDetails",JSON.stringify(result));
             window.location.reload();
            }
          });
        }
      });
    }


viewpayoutdetails(viewid:any,Mid:any){
  this.service.ViewPayOutContactDetails(viewid,Mid).subscribe(result => {
    if(result!=null){
    //  alert(result.PayoutCustomerkeyId)
      // this.datas=result;

this.ViewPayoutCustomerkeyId=result.PayoutCustomerkeyId;
this.ViewCustomerAccountId=result.CustomerAccountId;
this.ViewCustomerId=result.CustomerId;
this.ViewCompanyName=result.CompanyName;
this.ViewFirstName=result.FirstName;
this.ViewLastName=result.LastName;
this.ViewAddress=result.Address;
this.ViewCity=result.City;
this.ViewState=result.State;
this.ViewCountry=result.Country;
this.ViewZipCode=result.ZipCode;
this.ViewMobileNo=result.MobileNo;
this.ViewMobileNo2=result.MobileNo2;
this.ViewEmail=result.Email;
this.ViewEmail2=result.Email2;
this.ViewUpdatedDatetime=result.UpdatedDatetime;
this.ViewUserDefined1=result.UserDefined1;
this.ViewUserDefined2=result.UserDefined2;
this.ViewUserDefined3=result.UserDefined3;
this.ViewUserDefined4=result.UserDefined4;
this.ViewUserDefined5=result.UserDefined5;
this.ViewUserDefined7=result.UserDefined7;
this.ViewUserDefined6=result.UserDefined6;
this.ViewUserDefined8=result.UserDefined8;
this.ViewUserDefined9=result.UserDefined9;
this.ViewUserDefined10=result.UserDefined10;
    }
   
 
   
   
      })
    }

 
    toggleAccordian(event) {
      const element = event.target;
      element.classList.toggle("active");
      const panel = element.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    }	

    
  readAndExportTransactionData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.rows.length > 0) {
      this.rows.forEach(element => {
      
        var manageTranArray = { 'Payout Customer keyId': element.PayoutCustomerkeyId, 'CustomerId': element.CustomerId,
         'CompanyName': element.CompanyName, 'Name': element.FirstName, 'MobileNo': element.MobileNo, 'Email': element.Email, 'Datetime': element.UpdatedDatetime }
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
         { header: ['Payout Customer keyId', 'CustomerId', 'CompanyName', 'Name', 'MobileNo', 'Email', 'Datetime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManageTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }



  initiattransaction(CustomerKeyId)
  {
    this.PayoutCustomerkeyId=CustomerKeyId;

    this.service.ViewPayOutBeneficiarie(CustomerKeyId, this.MerchantKeyId).subscribe(res => {
    
      if(res.length <=0)
      {
        this.benficiarypopup();
      }
      else{

        // window.location.href=environment.RedirectViewbenficiary+this.PayoutCustomerkeyId;
        // this.router.navigate(['/PayOut/ViewBeneficiaries']);
        this.router.navigate(['/PayOut/ViewBeneficiaries',{PayoutCustomerkeyId: this.PayoutCustomerkeyId}]);

      }
    });
  }


  benficiarypopup()
  {
    swal({

      title: 'There is no beneficiary Please Create Beneficiary',
      // text: 'Are you sure you want to delete?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Cancel',
          value: null,
          visible: true,
          className: "",
          closeModal: true
        },
        confirm: {
          text: 'Create Beneficiary',
          value: true,
          visible: true,
          className: "bg-danger",
          closeModal: true
        }
      }
    }).then((isConfirm) => {
      if (isConfirm) {
        this.CreateBenficiary();
      } else {
        // swal('Cancelled', 'Your imaginary file is safe :)', 'error');
      }
    });
  }

  CreateBenficiary()
  {
    // this.router.navigate(['/PayOut/AddBeneficiaries'],{queryParams:{Id:this.PayoutCustomerkeyId}});
    window.location.href=environment.RedirectUrl+this.PayoutCustomerkeyId;

    // window.location.href=environment.RedirectUrl+this.PayoutCustomerkeyId;
  }




  getUserPermissions() {
    const merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.transactionservice.GetuserRoleBasedPermissions(merchantdata.UserId, "Merchant").subscribe(result => {
      if (result != null) {
        for (var i in result) {
          if (result[i].UserPermission == 'PayOut') {
            var type = result[i].Type;
            if (type == 'R') 
            {
                this.viewpayout=true;
                this.newpayout=false;
                this.editpayout=false;
                this.deletepayout=false;;
                this.createTransaction=false;;
                this.hidebeneficiary=false;
                this.Addbenificiaries=false;
            }
           else if (type == 'RW') 
            {
              this.viewpayout=true;
              this.newpayout=true;
              this.editpayout=true;
              this.deletepayout=false;;
              //this.createTransaction=true;;
              if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
              {
                this.createTransaction=true;
                this.hidebeneficiary=true;
              }
              else{
                this.createTransaction=false;
                this.hidebeneficiary=false;
              }
              this.Addbenificiaries=true;
            }
           else if (type == 'RWD') 
            {
              this.viewpayout=true;
              this.newpayout=true;
              this.editpayout=true;
              this.deletepayout=true;
              //this.createTransaction=true;;
              if(merchantdata.UserType !='Reseller' && merchantdata.UserType !='ResellerUser')
              {
                this.createTransaction=true;
                this.hidebeneficiary=true;
              }
              else{
                this.createTransaction=false;
                this.hidebeneficiary=false;
              }
              this.Addbenificiaries=true;
            }
          }
        }

      }

    });
  }


  resetForm(){

     
    this.daterange.reset(''); 
    this.CustomerId.reset(''); 
    this.CompanyName.reset('');
    this.Name.reset('');
    this.MobileNo.reset('');
    this.rows=[];
    
  
  }
}
